<template>
  <div :class="`formulate-input-element formulate-input-element--${context.type}`"
    :data-type="context.type"
  >
    <!-- placeholder="DD/MM/YYYY" -->

    <FormulateInput class="" type="text" readonly disabled
           :value="getDriver"
           v-bind="context.attributes" />

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { fulltextDate } from '@/helpers/dateHelper.js'

export default {
  props: {
    context: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      
    }
  },
  mounted () {

  },
  computed: {
    ...mapGetters({ client: 'client', answers: 'flattenedAnswers'}),

    getDriver () {

      let selectedDriver;

      if (this.$store.getters.client.drivers) {

        (this.$store.getters.client.drivers).forEach( (driver) => {
          if (driver.driver_id == this.$store.getters.client.selectedDriver) {
            selectedDriver = driver;
          }
        });
      }

      if (selectedDriver) {
        return selectedDriver.first_name + ' ' + selectedDriver.last_name + ' (' + fulltextDate(selectedDriver.dob) + ')';
      }

      return "Shouldn't display this";
    }
  },
  methods: {

  }
}
</script>

<style>

</style>